// Configurația rolurilor și permisiunilor
export const ROLES = {
  ADMIN: 1,
  MANAGER: 2,
  CONTABIL: 3,
  LOGISTIC: 4,
  FURNIZOR: 5
};

// Configurația permisiunilor pentru fiecare modul
export const PERMISSIONS = {
  // Pagini accesibile tuturor utilizatorilor autentificați
  COMMON: [ROLES.ADMIN, ROLES.MANAGER, ROLES.CONTABIL, ROLES.LOGISTIC],
  
  // Modulul Financiar - doar Admin și Contabil
  FINANCIAR: [ROLES.ADMIN, ROLES.CONTABIL],
  
  // Modulul Livrări - Admin și Logistic
  LIVRARI: [ROLES.ADMIN, ROLES.LOGISTIC],
  
  // Modulul Oferte - Admin și Manager
  OFERTE: [ROLES.ADMIN, ROLES.MANAGER, ROLES.LOGISTIC],
  
  // Modulul Achiziții - Admin, Manager și Contabil
  ACHIZITII: [ROLES.ADMIN, ROLES.MANAGER, ROLES.LOGISTIC],

  // Modulul Furnizori - Admin, Manager și Logistic
  FURNIZORI: [ROLES.ADMIN, ROLES.FURNIZOR, ROLES.LOGISTIC],

  ADMIN: [ROLES.ADMIN],

  WITHOUT_ADMIN: [ROLES.MANAGER, ROLES.CONTABIL, ROLES.LOGISTIC, ROLES.FURNIZOR],
};

// Funcție pentru verificarea permisiunilor
export const hasPermission = (userRole, requiredRoles) => {
  return requiredRoles.includes(Number(userRole));
};

// Funcție pentru obținerea descrierii rolului
export const getRoleDescription = (roleId) => {
  const roleNames = {
    [ROLES.ADMIN]: 'Administrator',
    [ROLES.MANAGER]: 'Manager',
    [ROLES.CONTABIL]: 'Contabil',
    [ROLES.LOGISTIC]: 'Logistic',
    [ROLES.FURNIZOR]: 'Furnizor'
  };
  return roleNames[roleId] || 'Rol necunoscut';
}; 